module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ../~/symbol-observable/index.js
// module id = 721
// module chunks = 2